module.exports = __webpack_public_path__ + "img/LogoKundenCrm.4ed58c35.png";